// eslint-disable-next-line
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import summaryApi from "./../common/Api";
import { useNavigate, useParams } from "react-router-dom";
import "react-image-gallery/styles/css/image-gallery.css";
import InnerImageZoom from "react-inner-image-zoom";
import { FaStar } from "react-icons/fa";
import { FaStarHalfAlt } from "react-icons/fa";
import HorizontalCardProduct from "../components/HorizontalCardProduct/HorizontalCardProduct";
import VerticalCardProduct from "../components/VerticalCardProduct/VerticalCardProduct";
import { MdOutlinePayments } from "react-icons/md";
import { FiShoppingBag } from "react-icons/fi";
import addToCart from "../helpers/addToCart";
import UserContext from "../context/context";
const ProductDetails = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const imageListing = new Array(data?.product_image?.length).fill(null); // data?.image?.map((image) => image.url);
  const { id: productId } = useParams();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const scrollElement = useRef();
  const navigate = useNavigate();

  const fetchProductDetails = async () => {
    try {
      const apiConfig = summaryApi.getProductDetails(productId);
      const response = await axios(apiConfig);

      setData(response.data?.data); // Assuming the API response structure
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error.message);
      setLoading(true);
    }
  };

  const { fetchCartCount } = useContext(UserContext);

  const [isClicked, setIsClicked] = useState(false);

  const handleAddToCart = async (e, productId) => {
    setIsClicked(true);
    try {
      await addToCart(e, productId);
      fetchCartCount();
    } catch (error) {
      console.error("Error adding product to cart:", error);
    } finally {
      setIsClicked(false);
    }
  };

  const handleBuy = async (e, productId) => {
    e.preventDefault(); // Prevent any default behavior
    setIsClicked(true);
    try {
      await addToCart(e, productId); // Add the product to the cart
      fetchCartCount(); // Update cart count
      navigate("/cart"); // Redirect to the cart page
    } catch (error) {
      console.error("Error adding product to cart:", error);
    } finally {
      setIsClicked(false);
    }
  };

  useEffect(() => {
    fetchProductDetails();
    if (scrollElement.current) {
      scrollElement.current.scrollTo({
        top: scrollElement.current.scrollHeight, // Scroll to the bottom
        behavior: "smooth",
      });
    }
  }, [productId]); // Ensure dependencies are correct

  return (
    <>
      <div className="container mx-auto p-4">
        <div className="flex flex-col md:flex-row justify-between mt-10 md:gap-10 gap-10 ">
          {loading ? (
            <>
              {/* image section */}
              <div className="flex flex-row md:flex-row gap-3 md:w-1/2">
                {/* */}
                {/* slide image  */}
                <div
                  ref={scrollElement}
                  className="flex gap-3 flex-col md:flex-col overflow-hidden items-start transition-all duration-300 scroll-none overflow-y-scroll md:overflow-x-unset max-h-[320px] md:max-h-[550px] md:overflow-y-scroll   scroll-smooth touch-auto "
                >
                  {imageListing?.map((image, index) => (
                    <div
                      key={index}
                      className="p-2 w-28 h-28 md:h-32 md:w-32 bg-slate-200 cursor-pointer flex-shrink-0 animate-pulse"
                    ></div>
                  ))}
                </div>

                {/* big image  */}
                <div className="w-[220px] h-[320px] md:w-[450px] flex justify-center items-center text-center md:h-[550px] p-2 bg-slate-200 cursor-pointer animate-pulse touch-auto"></div>
              </div>

              {/* details section  */}
              <div className="flex flex-col md:flex-row gap-5 md:w-1/2">
                <div className="flex flex-col gap-5 md:gap-8 w-full">
                  <div className="px-3 py-1 bg-[#5bc6c3] rounded-md p-3 w-1/4 h-4 text-[#5bc6c3] font-bold animate-pulse">
                    {" "}
                    {/* {data?.brand} */}
                  </div>
                  <h2 className="text-xl px-3 py-1rounded-md p-3 w-1/2 h-3 bg-slate-200 font-bold animate-pulse">
                    {/* {data?.name} */}
                  </h2>

                  <div className="flex flex-row gap-2 px-3 py-1rounded-md p-2 w-1/4 h-2 bg-slate-200 font-bold animate-pulse"></div>

                  {data?.discount > 0 ? (
                    <div className="flex flex-row gap-3 items-center">
                      <p className="text-black-400 font-bold text-2xl p-2  w-1/4 h-2 bg-slate-200 animate-pulse">
                        {/* ${data?.discount} */}
                      </p>
                      <p className="text-black-400 font-bold text-2xl p-2  w-1/4 h-2 bg-slate-200 animate-pulse">
                        {/* ${data?.price} */}
                      </p>
                    </div>
                  ) : (
                    <p className="text-black-400 font-bold text-2xl p-2  w-1/4 h-2 bg-slate-200 animate-pulse">
                      {/* ${data?.price} */}
                    </p>
                  )}

                  <p className="text-black-400 font-bold text-2xl p-2  w-1/4 h-2 bg-slate-200 animate-pulse">
                    {" "}
                    {/* Stock: <i>{data?.quantity}</i>{" "} */}
                  </p>

                  {data?.quantity > 0 ? (
                    <div className="flex gap-2 mb-2">
                      <button
                        // style={{ border: "2px solid red" }}
                        className="text-black-400 font-bold text-2xl p-4  w-1/2 h-4 bg-slate-200 animate-pulse"
                      >
                        {/* Buy Now */}
                      </button>

                      <button className="text-black-400 font-bold text-2xl p-4  w-1/2 h-4 bg-slate-200 animate-pulse">
                        {/* Add to Cart */}
                      </button>
                    </div>
                  ) : (
                    <div className="flex">
                      <div className="text-center font-bold text-2xl p-4  w-1/2 h-4 bg-slate-200 animate-pulse">
                        <p className="text-red-600 ">{/* Out of stock */}</p>
                      </div>
                    </div>
                  )}

                  <p className="font-bold text-2xl p-4  w-1/2 h-4 bg-slate-200 animate-pulse">
                    {/* {data?.description} */}
                  </p>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* image section */}
              <div className="flex flex-row md:flex-row gap-5 md:gap-10 md:w-1/2">
                {/* */}
                {/* slide image  */}
                <div
                  ref={scrollElement}
                  className="flex gap-3 flex-col md:flex-col overflow-hidden items-start scroll-none transition-all duration-300  overflow-y-scroll md:overflow-x-unset max-h-[320px] md:max-h-[550px] md:overflow-y-scroll   scroll-smooth touch-auto "
                >
                  {imageListing?.map((image, index) => (
                    <div
                      key={index}
                      className="flex justify-center items-center p-2 w-24 h-24 md:h-24 md:w-24 bg-slate-200 cursor-pointer flex-shrink-0 rounded-md hover:rotate-3 hover:scale-105 ease-in-out duration-300"
                    >
                      <img
                        src={data?.product_image[index]}
                        alt={data?.name}
                        loading="lazy"
                        effect="blur"
                        className="w-full h-full rounded-lg mix-blend-multiply object-contain  ease-in-out duration-300"
                        onMouseEnter={() => setSelectedImageIndex(index || 0)}
                      />
                    </div>
                  ))}
                </div>

                {/* big image  */}
                <div className="w-[220px] h-[320px] md:w-[450px] md:h-[550px] flex justify-center items-center text-center  p-2 bg-slate-200 cursor-pointer  touch-auto">
                  {data?.product_image?.length > 0 ? (
                    <div className="w-3/4 h-3/4 flex justify-center items-center object-contain">
                      <InnerImageZoom
                        src={data.product_image[selectedImageIndex || 0]}
                        zoomSrc={data.product_image[selectedImageIndex || 0]}
                        alt={data?.name || "Product Image"}
                        loading="lazy"
                        effect="blur"
                        className="w-full h-full p-5 rounded-lg mix-blend-multiply object-contain cursor-zoom-in "
                      />
                    </div>
                  ) : (
                    <p className="text-gray-500">No image available</p>
                  )}
                </div>
              </div>

              {/* details section  */}
              <div className="flex flex-col md:flex-row gap-5 md:w-1/2">
                <div className="flex flex-col gap-3 md:gap-4">
                  <div className="px-3 py-1 bg-[#c6f7ef] rounded-full w-fit text-[#5bc6c3] font-bold">
                    {" "}
                    {data?.brand}
                  </div>
                  <h2 className="text-2xl font-bold">{data?.name}</h2>

                  <div className="flex flex-row gap-2">
                    <FaStar className="text-yellow-400" />
                    <FaStar className="text-yellow-400" />
                    <FaStar className="text-yellow-400" />
                    <FaStar className="text-yellow-400" />
                    <FaStarHalfAlt className="text-yellow-400" />
                  </div>

                  {data?.discount > 0 ? (
                    <div className="flex flex-row gap-3 items-center">
                      <p className="text-black-400 font-bold text-2xl">
                        ${data?.discount}.00
                      </p>
                      <p className="text-[#536ea4] font-bold text-lg line-through">
                        ${data?.price}.00
                      </p>
                    </div>
                  ) : (
                    <p className="text-black-400 font-bold text-2xl">
                      ${data?.price}.00
                    </p>
                  )}

                  <p className="text-black-600 text-lg">
                    {" "}
                    Stock: <i>{data?.quantity}</i>{" "}
                  </p>

                  {data?.quantity > 0 ? (
                    <div className="flex gap-2 items-center mb-2">
                      <button
                        disabled={isClicked}
                        onClick={(e) => handleBuy(e, data._id)}
                        style={{ border: "2px solid #c6f7ef " }}
                        className="flex items-center gap-2 justify-center text-[#536ea4] px-4 py-2 transition-all duration-300 ease-in-out font-semibold rounded-md w-40 hover:bg-slate-100"
                      >
                        Buy Now
                        <span className="text-main-background">
                          {" "}
                          <MdOutlinePayments />{" "}
                        </span>
                      </button>

                      <button
                        disabled={isClicked}
                        onClick={(e) => handleAddToCart(e, data._id)}
                        style={{ border: "2px solid #fff" }}
                        className="flex items-center gap-2 rounded-ee-3xl justify-center text-white bg-main-background font-bold px-4 py-2 transition-all duration-300 ease-in-out rounded-md w-40 hover:bg-red-600 animate-pulse"
                      >
                        Add to Cart
                        <span className="text-white font-bold">
                          {" "}
                          <FiShoppingBag />{" "}
                        </span>
                      </button>
                    </div>
                  ) : (
                    <div className="flex">
                      <div className="text-center text-lg font-bold">
                        <p className="text-red-600 ">Out of stock</p>
                      </div>
                    </div>
                  )}

                  <p className="text-gray-600 capitalize ">
                    {data?.description}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="flex flex-col md:flex-row gap-2 pt-5 md:hidden">
          <h2 className="text-xl font-bold">Related Products</h2>
          <HorizontalCardProduct category={data?.category} heading={""} />
        </div>

        <div className="hidden md:block flex-col md:flex-row gap-2 pt-5 mt-10">
          <h2 className="text-2xl font-bold ">Related Products</h2>
          <div>
            <VerticalCardProduct category={data?.category} heading={""} />
          </div>
        </div>
      </div>

      {!data && (
        <div className="text-center text-lg font-bold mt-10">
          <p className="text-gray-600 mt-4">
            No products available. Please add some products.
          </p>
        </div>
      )}
    </>
  );
};

export default ProductDetails;
